import SiteLayout from "@/components/layouts/SiteLayout";
import LocationCard from "@/components/location/LocationCard";
import LocationController from "@/server/controllers/LocationController";
import CommonUtils from "@/utils/CommonUtils";
import LocationHelper from "@/utils/LocationHelper";
import { useState } from "react";

export async function getServerSideProps(context: any) {
  let location = null;

  const queryParams = context.query;
  let parent = queryParams.parent ? queryParams.parent : null;
  let parentId = null;

  if (parent) {
    location = await LocationController.getOne(parent);
    parentId = location.id;
  }

  let parent_level = queryParams.parent_level
    ? parseInt(queryParams.parent_level)
    : 0;
  let locationLevel = parent_level + 1;
  let pageSize = 1000;
  let locationData = await LocationController.getAllPaginated(
    locationLevel,
    parentId,
    1,
    pageSize
  );

  //sort by name
  locationData.data = locationData.data.sort((a, b) => {
    return a.name.localeCompare(b.name);
  });

  locationData = JSON.parse(JSON.stringify(locationData));
  location = JSON.parse(JSON.stringify(location));
  const locale = context.locale;
  let queryInfo = await LocationHelper.getQueryPramsInfo(location, locale);

  return { props: { location, locationData, queryParams, queryInfo } };
}

const Locations = ({ location, locationData, queryParams, queryInfo }) => {
  const [showFilter, setShowFilter] = useState(true);

  return (
    <SiteLayout
      title={queryInfo.seoTitle + " | " + CommonUtils.appName}
      description={queryInfo.seoDescription}
    >
      <div className="container mx-auto mb-10 sm:mt-auto -mt-[40px]">
        <div className=" ">
          <h1 className="text-2xl font-bold text-gray-800 mb-1">
            {queryInfo.pageTitle}
          </h1>
          <p>{queryInfo.pageDescription}</p>
          <div className="mt-4 space-y-4">
            {locationData.data.map((location, index) => (
              <LocationCard
                key={location.id}
                name={location.name}
                uuid={location.uuid}
                id={location.id}
                level={location.level}
                index={index + 1}
              />
            ))}
          </div>
        </div>
      </div>
    </SiteLayout>
  );
};

export default Locations;
